import { ToolDefinition } from "./toolDefinitionsConfig";

export const TOOL_REGISTRY: ToolDefinition[] = [
  // Navigation
  {
    id: 'Scroll',
    name: 'Scroll',
    group: 'navigation',
    behavior: 'exclusive',
    shortcut: [{ key: '1', description: 'Scroll slices' }],
    visibility: {
      panels: ['DICOMPanel', 'CPRPanel', 'CrossSectionPanel'],
    },
    onActivate: (ctx) => {
      console.log('🧭 Scroll activated');
    },
  },
  {
    id: 'Rotation',
    name: 'Rotate',
    group: 'navigation',
    behavior: 'exclusive',
    shortcut: [{ key: '1', description: 'Rotate 3D / Volume' }],
    visibility: {
      panels: ['VRPanel', 'Surface3DPanel'],
      panelAnalyses: {
        DICOMPanel: ['chamber'],
      },
    },
    onActivate: (ctx) => {
      console.log('Rotation');
    },
  },
  {
    id: 'Pan',
    name: 'Pan',
    group: 'navigation',
    behavior: 'exclusive',
    shortcut: [{ key: '2', description: 'Pan image' }],
    visibility: {
      panels: [
        'DICOMPanel',
        'VRPanel',
        'Surface3DPanel',
        'CPRPanel',
        'CrossSectionPanel',
      ],
    },
    onActivate: (ctx) => {
      console.log('Pan');
    },
  },
  {
    id: 'Zoom',
    name: 'Zoom',
    group: 'navigation',
    behavior: 'exclusive',
    shortcut: [{ key: '3', description: 'Zoom in/out' }],
    visibility: {
      panels: [
        'DICOMPanel',
        'VRPanel',
        'Surface3DPanel',
        'CPRPanel',
        'CrossSectionPanel',
      ],
    },
    onActivate: (ctx) => {
      console.log('Zoom');
    },
  },
  {
    id: 'WindowLevel',
    name: 'Window / Level',
    group: 'navigation',
    behavior: 'exclusive',
    shortcut: [{ key: '4', description: 'Adjust window / level' }],
    visibility: {
      panels: ['DICOMPanel', 'CPRPanel', 'CrossSectionPanel'],
      panelAnalyses: {
        VRPanel: ['segmentation'],
      },
    },
    enabled: (ctx) => {
      if (
        ctx.analysisMode === 'segmentation' &&
        ctx.selectedPanelComponentKey === 'VR'
      ) {
        return (
          ctx.state.isToggleMIP &&
          ctx.layoutConfig.panelConfig.some(
            (panel) => panel.panelId === 'VRPanel',
          )
        );
      }
      return true;
    },
  },

  // Measurement
  {
    id: 'Length',
    name: 'Length',
    group: 'measurement',
    behavior: 'exclusive',
    visibility: { panels: ['DICOMPanel'] },
    enabled: (ctx) =>
      ctx.analysisMode !== 'chamber' && ctx.state.isShowMeasurement,
  },
  {
    id: 'Angle',
    name: 'Angle',
    group: 'measurement',
    behavior: 'exclusive',
    visibility: { panels: ['DICOMPanel'] },
    enabled: (ctx) =>
      ctx.analysisMode !== 'chamber' && ctx.state.isShowMeasurement,
  },
  {
    id: 'CobbAngle',
    name: 'CobbAngle',
    group: 'measurement',
    behavior: 'exclusive',
    visibility: { panels: ['DICOMPanel'] },
    enabled: (ctx) =>
      ctx.analysisMode !== 'chamber' && ctx.state.isShowMeasurement,
  },
  {
    id: 'Spline',
    name: 'Spline',
    group: 'measurement',
    behavior: 'exclusive',
    visibility: { panels: ['DICOMPanel'] },
    enabled: (ctx) =>
      ctx.analysisMode !== 'chamber' && ctx.state.isShowMeasurement,
  },
  {
    id: 'FreeHand',
    name: 'Free Hand',
    group: 'measurement',
    behavior: 'exclusive',
    visibility: { panels: ['DICOMPanel'] },
    enabled: (ctx) =>
      ctx.analysisMode !== 'chamber' && ctx.state.isShowMeasurement,
  },
  // {
  //   id: 'Ellipse',
  //   name: 'Ellipse ROI',
  //   group: 'measurement',
  //   behavior: 'exclusive',
  //   visibility: { panels: ['DICOMPanel'] },
  //   enabled: (ctx) => ctx.state.isShowMeasurement
  // },
  {
    id: 'Rectangle',
    name: 'Rectangle ROI',
    group: 'measurement',
    behavior: 'exclusive',
    visibility: { panels: ['DICOMPanel'] },
    enabled: (ctx) =>
      ctx.analysisMode !== 'chamber' && ctx.state.isShowMeasurement,
  },
  {
    id: 'Measurement3D',
    name: '3D Measurement',
    group: 'measurement',
    behavior: 'exclusive',
    visibility: { panels: ['VRPanel', 'Surface3DPanel'] },
    enabled: (ctx) =>
      ctx.analysisMode !== 'chamber' && ctx.state.isShowMeasurement,
  },

  // Manual Segmentation
  {
    id: 'Brush',
    name: 'Brush',
    group: 'manual',
    behavior: 'exclusive',
    visibility: {
      // panels: ['DICOMPanel','Surface3DPanel','VRPanel'],
      panelAnalyses: {
        DICOMPanel: ['segmentation', 'FFR'],
        Surface3DPanel: ['segmentation', 'FFR'],
        VRPanel: ['segmentation', 'FFR'],
      },
    },
    enabled: (ctx) => ctx.state.isSegmentationManager,
  },
  {
    id: 'Eraser',
    name: 'Eraser',
    group: 'manual',
    behavior: 'exclusive',
    visibility: {
      // panels: ['DICOMPanel','Surface3DPanel','VRPanel'],
      panelAnalyses: {
        DICOMPanel: ['segmentation', 'FFR'],
        Surface3DPanel: ['segmentation', 'FFR'],
        VRPanel: ['segmentation', 'FFR'],
      },
    },
    enabled: (ctx) => ctx.state.isSegmentationManager,
  },
  {
    id: 'FloodFill',
    name: 'Flood Fill',
    group: 'manual',
    behavior: 'exclusive',
    visibility: {
      // panels: ['DICOMPanel','Surface3DPanel','VRPanel'],
      panelAnalyses: {
        DICOMPanel: ['segmentation'],
        Surface3DPanel: ['segmentation'],
        VRPanel: ['segmentation'],
      },
    },
    enabled: (ctx) => ctx.state.isSegmentationManager,
  },
  {
    id: 'Connect2D',
    name: 'Connect 2D',
    group: 'manual',
    behavior: 'exclusive',
    visibility: {
      panelAnalyses: {
        DICOMPanel: ['FFR'],
      },
    },
    enabled: (ctx) => ctx.state.isSegmentationManager,
  },
  {
    id: 'connectPoint',
    name: 'Point Connect',
    group: 'manual',
    behavior: 'exclusive',
    visibility: {
      panelAnalyses: {
        DICOMPanel: ['FFR'],
      },
    },
    enabled: (ctx) => ctx.state.isSegmentationManager,
  },
  // Toggle
  {
    id: 'ToggleAxes',
    name: 'Show Axes',
    group: 'annotation',
    behavior: 'toggle',
  },
  {
    id: 'ToggleMeasurementVisibility',
    name: 'Show Measurements',
    group: 'annotation',
    behavior: 'toggle',
  },
  {
    id: 'ToggleAnnotations',
    name: 'Show Annotations',
    group: 'annotation',
    behavior: 'toggle',
  },
  {
    id: 'TogglePatientData',
    name: 'Show Patient Info',
    group: 'annotation',
    behavior: 'toggle',
  },
  {
    id: 'ToggleDicomZoomSync',
    name: 'Sync CT Zoom',
    group: 'annotation',
    behavior: 'toggle',
  },
  {
    id: 'ToggleDicomPanSync',
    name: 'Sync CT Pan',
    group: 'annotation',
    behavior: 'toggle',
  },
  {
    id: 'ToggleDICOMTags',
    name: 'Show DICOM Tags',
    group: 'annotation',
    behavior: 'toggle',
  },
  {
    id: 'ToggleSegmentationManager',
    name: 'Segment Manager',
    group: 'utility',
    behavior: 'toggle',
    icon: 'segmentManager',
    visibility: {
      analyses: [
        'segmentation',
        'aorticValveCalcium',
        'calciumScore',
        'fai',
        'isr',
        'myocardial',
        'wallthickness',
        'plaque',
        'stenosis',
        'FFR',
        'chamber',
        'tavi',
      ],
    },
  },
  // {
  //   id: 'ToggleSync',
  //   name: 'Sync CT Views',
  //   group: 'utility',
  //   behavior: 'toggle',
  //   visibility: {
  //     panelAnalyses: {
  //       DICOMPanel: ['MPR', 'segmentation', 'ejectionFraction', 'myocardial', 'wallthickness', 'calciumScore'],
  //     },
  //   },
  // },
  // Momentary
  {
    id: 'Report',
    name: 'Report',
    group: 'system',
    behavior: 'momentary',
    icon: 'report',
    visibility: {
      analyses: [
        'aorticValveCalcium',
        'calciumScore',
        'fai',
        'isr',
        'myocardial',
        'wallthickness',
        'plaque',
        'stenosis',
        'ejectionFraction',
        'tavi',
      ],
    },
  },
  {
    id: 'ResetView',
    name: 'ResetView',
    group: 'utility',
    icon: 'refresh',
    behavior: 'momentary',
    shortcut: [{ key: 'Ctrl+`', description: 'Reset view' }],
  },
  {
    id: 'RotateCW90',
    name: 'Rotate CW 90°',
    group: 'utility',
    behavior: 'momentary',
    visibility: { panels: ['DICOMPanel'] },
  },
  {
    id: 'RotateCCW90',
    name: 'Rotate CWW 90°',
    group: 'utility',
    behavior: 'momentary',
    visibility: { panels: ['DICOMPanel'] },
  },
  {
    id: 'FlipVertical',
    name: 'Flip Vertical',
    group: 'utility',
    behavior: 'momentary',
    visibility: { panels: ['DICOMPanel'] },
  },
  {
    id: 'FlipHorizontal',
    name: 'Flip Horizontal',
    group: 'utility',
    behavior: 'momentary',
    visibility: { panels: ['DICOMPanel'] },
  },
  {
    id: 'FitToScreen',
    name: 'FitToScreen',
    group: 'utility',
    behavior: 'momentary',
    visibility: { panels: ['DICOMPanel'] },
  },
  {
    id: 'OneOnOneResolution',
    name: 'OneOnOneResolution',
    group: 'utility',
    behavior: 'momentary',
    visibility: { panels: ['DICOMPanel'] },
  },
  // AutoCapture
  {
    id: 'AutoCapture_Segmentation_3D_MultiView',
    name: 'Segmentation 3D Multi',
    group: 'autocapture',
    behavior: 'momentary',
    visibility: { analyses: ['segmentation'] },
  },
  {
    id: 'AutoCapture_Segmentation_3D_SingleCapture',
    name: 'Segmentation 3D Single',
    group: 'autocapture',
    behavior: 'momentary',
    visibility: { analyses: ['segmentation'] },
  },
  {
    id: 'AutoCapture_Chamber_SingleView',
    name: 'Chamber Single View',
    group: 'autocapture',
    behavior: 'momentary',
    visibility: { analyses: ['chamber'] },
  },
  {
    id: 'AutoCapture_Chamber_FullView',
    name: 'Chamber Full View',
    group: 'autocapture',
    behavior: 'momentary',
    visibility: { analyses: ['chamber'] },
  },
  {
    id: 'AutoCapture_Plaque_SingleCPRView',
    name: 'Plaque Single CPR',
    group: 'autocapture',
    behavior: 'momentary',
    visibility: { analyses: ['plaque'] },
  },
  {
    id: 'AutoCapture_Plaque_MainCPRView',
    name: 'Plaque Main CPR',
    group: 'autocapture',
    behavior: 'momentary',
    visibility: { analyses: ['plaque'] },
  },
  {
    id: 'AutoCapture_Plaque_FullCPRView',
    name: 'Plaque Full CPR',
    group: 'autocapture',
    behavior: 'momentary',
    visibility: { analyses: ['plaque'] },
  },
  {
    id: 'AutoCapture_Plaque_LesionStackCapture',
    name: 'Lesion Stack Capture',
    group: 'autocapture',
    behavior: 'momentary',
    visibility: { analyses: ['plaque'] },
  },
  // Segmentation - VR or 3D
  {
    id: 'ToggleHeartCut',
    name: 'ToggleHeartCut',
    group: 'utility',
    behavior: 'toggle',
    visibility: { analyses: ['segmentation', 'plaque'] },
    enabled: (ctx) => !ctx.state.isToggleMIP,
  },
  {
    id: 'ToggleMIP',
    name: 'ToggleMIP',
    group: 'utility',
    behavior: 'toggle',
    visibility: { analyses: ['segmentation', 'plaque'] },
    enabled: (ctx) =>
      ctx.layoutConfig.panelConfig.some((panel) => panel.panelId === 'VRPanel'),
  },
  {
    id: 'Ventricle',
    name: 'Ventricle',
    group: 'utility',
    behavior: 'momentary',
    visibility: { analyses: ['segmentation', 'plaque'] },
    enabled: (ctx) => !ctx.state.isToggleMIP,
  },
  {
    id: 'CoronaryAorta',
    name: 'CoronaryAorta',
    group: 'utility',
    behavior: 'momentary',
    visibility: { analyses: ['segmentation', 'plaque'] },
    enabled: (ctx) => !ctx.state.isToggleMIP,
  },
  {
    id: 'ColorPreset_Type1',
    name: 'ColorPreset_Type1',
    group: 'utility',
    behavior: 'momentary',
    visibility: { analyses: ['segmentation', 'plaque'] },
    enabled: (ctx) =>
      !ctx.state.isToggleMIP &&
      ctx.layoutConfig.panelConfig.some((panel) => panel.panelId === 'VRPanel'),
  },
  {
    id: 'ColorPreset_Type2',
    name: 'ColorPreset_Type2',
    group: 'utility',
    behavior: 'momentary',
    visibility: { analyses: ['segmentation', 'plaque'] },
    enabled: (ctx) =>
      !ctx.state.isToggleMIP &&
      ctx.layoutConfig.panelConfig.some((panel) => panel.panelId === 'VRPanel'),
  },
  {
    id: 'ColorPreset_Type3',
    name: 'ColorPreset_Type3',
    group: 'utility',
    behavior: 'momentary',
    visibility: { analyses: ['segmentation', 'plaque'] },
    enabled: (ctx) =>
      !ctx.state.isToggleMIP &&
      ctx.layoutConfig.panelConfig.some((panel) => panel.panelId === 'VRPanel'),
  },
  {
    id: 'TogglePlaqueManual',
    name: 'Edit',
    group: 'manual',
    behavior: 'toggle',
    icon: 'edit',
    visibility: { analyses: ['plaque'] },
  },
  {
    id: 'Edit',
    name: 'Edit',
    group: 'manual',
    icon: 'edit',
    behavior: 'momentary',
    visibility: { analyses: ['FFR'] },
  },
];
